// src/index.js
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './Auth/AuthContext';
import './index.css';
import './styles/theme.css'; // Import the new theme CSS
import './styles/modern-cards.css'; // Import modern card styles
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Import Bootstrap JavaScript

// Add global error handlers for better debugging
window.addEventListener('error', (event) => {
  console.error('Global error caught:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error,
    stack: event.error?.stack
  });
});

// Add unhandled promise rejection handler
window.addEventListener('unhandledrejection', (event) => {
  console.error('🚨 UNHANDLED PROMISE REJECTION DETECTED 🚨');
  console.error('Reason:', event.reason);
  // Don't access event.promise as it causes errors
  console.error('Type of reason:', typeof event.reason);
  
  // Try to extract more details safely
  if (event.reason) {
    try {
      if (event.reason.stack) {
        console.error('Stack trace:', event.reason.stack);
      }
      if (event.reason.message) {
        console.error('Message:', event.reason.message);
      }
      if (event.reason.code) {
        console.error('Code:', event.reason.code);
      }
      if (event.reason.name) {
        console.error('Name:', event.reason.name);
      }
    } catch (loggingError) {
      console.error('Error while logging rejection details:', loggingError);
    }
  }
  
  // DON'T prevent default in development to see the actual error
  if (process.env.NODE_ENV === 'development') {
    console.warn('⚠️ Allowing default error handling to show full error details');
    // Don't call event.preventDefault() in development
  } else {
    // Only prevent default in production
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();